module.exports = __webpack_public_path__ + "static/media/GalleryImage12.81df223e.jpg";